import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Marketplace from "@/pages/Marketplace";
import HotelDetail from "@/pages/HotelDetail";
import NegotiationRoom from "@/pages/NegotiationRoom";
import CompanyDashboard from "@/pages/CompanyDashboard";
import HotelDashboard from "@/pages/HotelDashboard";
import GmDashboard from "@/pages/GmDashboard";
import FrontDeskDashboard from "@/pages/FrontDeskDashboard";
import ProspectSearch from "@/pages/ProspectSearch";
import LeadDetail from "@/pages/LeadDetail";
import SalesDashboard from "@/pages/SalesDashboard";
import InvitePage from "@/pages/InvitePage";
import IntakeForm from "@/pages/IntakeForm";
import RolesPage from "@/pages/RolesPage";

function Shell({ children }) {
  return (<><Nav />{children}</>);
}

function AppRoutes() {
  const { user, ready, homePath } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Shell><Landing /></Shell>} />
      <Route path="/invite/:id" element={<InvitePage />} />
      <Route path="/intake/:token" element={<IntakeForm />} />
      <Route path="/login" element={!ready ? null : user ? <Navigate to={homePath()} replace /> : <Login />} />
      <Route path="/register" element={!ready ? null : user ? <Navigate to={homePath()} replace /> : <Register />} />

      <Route path="/marketplace" element={<ProtectedRoute roles={["company", "hotel_gm"]}><Shell><Marketplace /></Shell></ProtectedRoute>} />
      <Route path="/hotels/:id" element={<ProtectedRoute roles={["company", "hotel_gm"]}><Shell><HotelDetail /></Shell></ProtectedRoute>} />
      <Route path="/negotiation/:rfpId" element={<ProtectedRoute roles={["company", "hotel_gm", "gm", "rm", "dos"]}><Shell><NegotiationRoom /></Shell></ProtectedRoute>} />

      <Route path="/company" element={<ProtectedRoute roles={["company"]}><Shell><CompanyDashboard /></Shell></ProtectedRoute>} />

      <Route path="/hotel" element={<ProtectedRoute roles={["hotel_gm"]}><Shell><HotelDashboard /></Shell></ProtectedRoute>} />
      <Route path="/gm" element={<ProtectedRoute roles={["gm", "rm", "dos"]}><Shell><GmDashboard /></Shell></ProtectedRoute>} />
      <Route path="/front-desk" element={<ProtectedRoute roles={["front_desk"]}><Shell><FrontDeskDashboard /></Shell></ProtectedRoute>} />
      <Route path="/prospect" element={<ProtectedRoute roles={["hotel_gm", "gm", "rm", "dos", "sales"]}><Shell><ProspectSearch /></Shell></ProtectedRoute>} />

      <Route path="/sales" element={<ProtectedRoute roles={["sales"]}><Shell><SalesDashboard /></Shell></ProtectedRoute>} />

      <Route path="/leads/:leadId" element={<ProtectedRoute roles={["hotel_gm", "gm", "rm", "dos", "sales"]}><Shell><LeadDetail /></Shell></ProtectedRoute>} />

      <Route path="/roles" element={<ProtectedRoute roles={["hotel_gm", "gm", "rm", "dos", "sales", "front_desk"]}><Shell><RolesPage /></Shell></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
